// extracted by mini-css-extract-plugin
module.exports = {"root":"LinkSection_root__2BUMn","heading":"LinkSection_heading__3u2DC","link":"LinkSection_link__2J5DF"};